import { Component, OnInit, ViewChild } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { UserService } from 'src/app/core/services/user.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { SalesSummary } from 'src/app/shared/models/SalesSummary.model';
import { ItemDashComponent } from './item-dash/item-dash.component';
import { LaborDashComponent } from './labor-dash/labor-dash.component';
import { SalesDashComponent } from './sales-dash/sales-dash.component';

@Component({
	selector: 'app-dashboard-v2',
	templateUrl: './dashboard-v2.component.html',
	styleUrls: ['../commandcenter.scss'],
})
export class DashboardV2Component implements OnInit {
	@ViewChild('salesDash') salesDash: SalesDashComponent;
	@ViewChild('laborDash') laborDash: LaborDashComponent;
	@ViewChild('itemDash') itemDash: ItemDashComponent;

	currentCheckDate: string = this.app.moment().format('MMDDYYYY');
	currentDaySalesSummary: SalesSummary;
	dateSelectorEnabled = {
		next: false,
		prev: true,
	};

	dashboardOptions: GenericLabelValue[] = [
		{
			label: 'Sales',
			value: 1,
			sortVal: 0,
		},
		{
			label: 'Labor',
			value: 2,
			sortVal: 1,
		},
		{
			label: 'Item',
			value: 3,
			sortVal: 2,
		},
		{
			label: 'Online',
			value: 4,
			sortVal: 3,
			disabled: true,
		},
	];

	selectedDashboard: number = 1;
	loadedVenueKey: number;
	loadingDashboard: boolean = true;

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService, public userService: UserService) {}

	ngOnInit(): void {
		this.venueService.subscriptionVenue.subscribe((venue) => {
			if (venue && venue.key && this.loadedVenueKey !== venue.key) {
				console.log('call to load venueData');
				this.loadingDashboard = true;
				this.loadVenueData(venue.key);
			}
		});
		this.venueService.salesSummaryList.subscribe((data) => {
			if (data?.length > 0) {
				this.currentDaySalesSummary = data.find((i) => i.checkDate === this.currentCheckDate);
				this.loadingDashboard = false;
			}
		});
		this.selectedDashboard =
			this.dashboardOptions.find((i) => i.label.toLowerCase() === this.userService.userSubscription?.value?.dashboardDefault)?.value || 1;
	}

	checkDateChange(direction: string) {
		let checkDateSelected;
		switch (direction) {
			case 'prev':
				checkDateSelected = this.app.moment(this.currentCheckDate, 'MMDDYYYY').add(-1, 'days');
				break;
			case 'next':
				checkDateSelected = this.app.moment(this.currentCheckDate, 'MMDDYYYY').add(1, 'days');
				break;
		}

		if (this.venueService.salesSummaryList.value.some((i) => i.checkDate === checkDateSelected.format('MMDDYYYY'))) {
			this.currentCheckDate = checkDateSelected.format('MMDDYYYY');
			this.currentDaySalesSummary = this.venueService.salesSummaryList.value.find((i) => i.checkDate === this.currentCheckDate);
		}
		this.dateSelectorEnabled.prev = this.venueService.salesSummaryList.value.some(
			(i) => i.checkDate === this.app.moment(checkDateSelected).subtract(1, 'days').format('MMDDYYYY')
		);
		this.dateSelectorEnabled.next = this.venueService.salesSummaryList.value.some(
			(i) => i.checkDate === this.app.moment(checkDateSelected).add(1, 'days').format('MMDDYYYY')
		);

		if (
			this.venueService.salesSummaryList.value.length -
				this.venueService.salesSummaryList.value.findIndex((i) => i.checkDate === this.currentCheckDate) ===
			10
		) {
			const lastCheckDate = this.venueService.salesSummaryList.value[this.venueService.salesSummaryList.value.length - 1].checkDate;
			this.venueService.salesSummayV4GetRange(
				this.venueService.venueKey,
				this.app.moment(lastCheckDate, 'MMDDYYYY').add(-2, 'days').format('MMDDYYYY'),
				this.app.moment(lastCheckDate, 'MMDDYYYY').format('MMDDYYYY')
			);
			this.venueService.timecardRecordGetList(
				this.venueService.subscriptionVenue.value.key,
				this.app.moment(lastCheckDate, 'MMDDYYYY').add(-2, 'days').format('MMDDYYYY'),
				this.app.moment(lastCheckDate, 'MMDDYYYY').format('MMDDYYYY')
			);
		}
	}

	async loadVenueData(venueKey: number) {
		this.loadedVenueKey = venueKey;
		this.salesDash && (this.salesDash.metrics.loadComplete = false);
		this.laborDash && (this.laborDash.metrics.loadComplete = false);
		this.venueService.salesDashboardGet(venueKey, this.currentCheckDate);
		this.venueService.productStatisticMetricGet();

		this.venueService.checksGetOnline(venueKey, this.app.moment().format('YYYY-MM-DD'));
		this.venueService.checksGetOnline(venueKey, this.app.moment().add(-1, 'day').format('YYYY-MM-DD'));
		this.venueService.timecardRecordGetList(venueKey, this.app.moment().add(-30, 'days').format('MMDDYYYY'), this.app.moment().format('MMDDYYYY'));
	}

	setDashboardAsFavorite() {
		this.userService.userDashboardDefaultSave(this.dashboardOptions.find((i) => i.value === this.selectedDashboard).label.toLowerCase());
	}

	refeshData() {
		this.venueService.salesSummaryList.next([]);
		this.venueService.salesSummayV4GetRange(
			this.venueService.subscriptionVenueKey.value,
			this.app.moment().add(-30, 'days').format('MMDDYYYY'),
			this.app.moment().format('MMDDYYYY')
		);
		this.venueService.salesSummaryList.subscribe((data) => {
			this.app.msgSvc.add({ severity: AppMessageSeverity.INFO, summary: '', detail: `Sales Summary Loaded` });
		});
	}
}
